(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["what-to-expect"] && !Shopify.designMode) return;
  try {
    
const headers = document.querySelectorAll(".what-to-expect .accordion-header");

headers.forEach(header => {
  header.addEventListener("click", () => {
    const content = header.nextElementSibling;

    if (content.classList.contains("open")) {
      content.style.maxHeight = null;
      content.classList.remove("open");
      header.classList.remove("active");
    } else {
      document.querySelectorAll(".what-to-expect .accordion-content").forEach(c => {
        c.style.maxHeight = null;
        c.classList.remove("open");
      });
      document.querySelectorAll(".what-to-expect .accordion-header").forEach(h => h.classList.remove("active"));

      header.classList.add("active");
      content.classList.add("open");
      content.style.maxHeight = 65 + "px";
    }
  });
});

const firstOpen = document.querySelector(".what-to-expect .accordion-content.open");
if (firstOpen) {
  firstOpen.style.maxHeight = 65 + "px";
}

  } catch(e) { console.error(e); }
})();
})();
